import React from "react";

// Atom: Text Input (text / email / tel). One definition; the `type` prop is
// the variant. All instances share .smww-input, so a single CSS edit restyles
// every text input in the system (QA Proof #4).
const TextInput = ({ type = "text", className = "smww-input", ...props }) => (
    <input
        type={type}
        className={className}
        data-atomic="atom"
        data-atomic-name="text-input"
        {...props}
    />
);

export default TextInput;
